import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    marginTop: theme.spacing(4),
    '&> div': {
      borderTop: `1px solid ${theme.colorPalette.white_30_op_30} `
    },
    '&> div:first-child': {
      borderTop: 'none'
    },
    marginBottom: theme.spacing(4),
    padding: theme.spacing(4),
    minHeight: 60
  },
  primary: {
    backgroundColor: theme.colorPalette.orange_50
  },
  secondary: {
    backgroundColor: theme.colorPalette.white_10,
    color: theme.colorPalette.green_30
  },
  tertiary: {
    backgroundColor: theme.colorPalette.green_15,
    color: theme.colorPalette.white_10
  },
  quaternary: {
    backgroundColor: theme.colorPalette.green_30,
    color: theme.colors.light_text,
    padding: theme.spacing(7, 5)
  },
  light: {
    backgroundColor: theme.colorPalette.beige_10,
    color: theme.colorPalette.green_20
  },
  noBackground: {
    display: 'flex',
    color: theme.colors.light_text,
    backgroundColor: 'transparent',
    fontSize: 14,
    margin: 0,
    alignItems: 'center',
    '&> img': {
      marginRight: 0
    }
  },
  icon: {
    marginRight: theme.spacing(4),
    width: 50,
    height: 30
  },
  quaternaryIcon: {
    marginRight: 0,
    height: 32,
    width: 32
  },
  notificationContentContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%'
  },
  iconColumn: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    paddingTop: theme.spacing(1)
  },
  headerContainer: {
    display: 'flex'
  },
  header: {
    margin: theme.spacing(2, 0)
  }
}));

export default useStyles;
